<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="7em" class="baseInfoForm">

            <el-form-item label="培训课程" prop="recordName">
                <el-input
                        v-model="form.recordName"
                        placeholder="请输入课程名称"
                        maxlength="30">
                </el-input>
            </el-form-item>
            
            <el-form-item label="就读时间" required>
                <el-col :span="11">
                    <el-form-item prop="startTime">
                        <el-date-picker
                                v-model="form.startTime"
                                type="date"
                                placeholder="开始日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2" class="line">至</el-col>
                <el-col :span="11">
                    <el-form-item prop="endTime">
                        <el-date-picker
                                v-model="form.endTime"
                                type="date"
                                placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>

            <el-form-item label="培训机构" prop="orgName">
                <el-input
                        v-model="form.orgName"
                        placeholder="请输入机构名称"
                        maxlength="30">
                </el-input>
            </el-form-item>
            <el-form-item label="培训描述" prop="description">
                <el-input
                        type="textarea"
                        v-model="form.description"
                        placeholder="讲一讲你的培训经历吧，注意不要泄露个人隐私，如手机号、QQ、微信、家庭住址等"
                        maxlength="800"
                        show-word-limit>
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="updateTrainingExperience()" v-if="editStatus.status==true">更新保存</el-button>
                <el-button type="primary" @click="saveTrainingExperience()" v-else>保存</el-button>
                <el-popconfirm title="确认取消编辑？"
                    @confirm="cancel()"
                    placement="top-start"
                    icon="el-icon-info"
                    icon-color="red"
                    class="ml10">
                    <el-button slot="reference">取消</el-button>
                </el-popconfirm>
            </el-form-item>

        </el-form>
    </div>
</template>
<script>
    import {saveTrainingExperience,updateTrainingExperience} from '@/api/resume';

    export default {
        name: 'trainingExperienceForm',
        props: ['form','resumeId','editStatus'],
        data() {
            return {
                rules: {
                    recordName: [
                        {required: true, message: '请输入培训课程'},
                        {max: 10},
                        {pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,30}$/, message: '支持输入中英文和数字'}
                    ],
                    startTime: [
                        {required: true, message: '请选择培训时间'},
                    ],
                    endTime: [
                        {required: true, message: '请选择培训时间'},
                    ],
                    orgName: [
                        {required: true, message: '请输入培训机构'},
                        {max: 30, message: '字符数不可超过30'},
                        {pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,30}$/, message: '支持输入中英文和数字'}
                    ],
                    description: [
                        {max: 800, message: '字符数不可超过800'},
                    ],
                },
            }
        },
        methods: {
            saveTrainingExperience(){
                this.$refs["form"].validate(valid=>{
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        saveTrainingExperience(this.form).then(res=>{
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历培训经历保存失败");
                        })
                    }
                })
            },

            updateTrainingExperience(){
                this.$refs["form"].validate(valid=>{
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        updateTrainingExperience(this.form).then(res=>{
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历培训经历保存失败");
                        })
                    }
                })
            },

            // 简历工作经历表单取消编辑状态
            cancel() {
                this.editStatus.id = 0;
                this.editStatus.status = false;
                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeTrainingExperienceEditStatus', false);
            },
        }

    }
</script>